module.exports = __webpack_public_path__ + "img/Kuwait.9134280f.svg";